// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {PDFBoxLayout} from '../search-index/pdfbox-layout.js'

export class PDFPageTextLayout {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): PDFPageTextLayout {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsPDFPageTextLayout(bb: flatbuffers.ByteBuffer, obj?: PDFPageTextLayout): PDFPageTextLayout {
    return (obj || new PDFPageTextLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsPDFPageTextLayout(
    bb: flatbuffers.ByteBuffer,
    obj?: PDFPageTextLayout
  ): PDFPageTextLayout {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new PDFPageTextLayout()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  pageNumber(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
  }

  boxes(index: number, obj?: PDFBoxLayout): PDFBoxLayout | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset
      ? (obj || new PDFBoxLayout()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!
        )
      : null
  }

  boxesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  static startPDFPageTextLayout(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addPageNumber(builder: flatbuffers.Builder, pageNumber: number) {
    builder.addFieldInt16(0, pageNumber, 0)
  }

  static addBoxes(builder: flatbuffers.Builder, boxesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, boxesOffset, 0)
  }

  static createBoxesVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startBoxesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static endPDFPageTextLayout(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 6) // boxes
    return offset
  }

  static createPDFPageTextLayout(
    builder: flatbuffers.Builder,
    pageNumber: number,
    boxesOffset: flatbuffers.Offset
  ): flatbuffers.Offset {
    PDFPageTextLayout.startPDFPageTextLayout(builder)
    PDFPageTextLayout.addPageNumber(builder, pageNumber)
    PDFPageTextLayout.addBoxes(builder, boxesOffset)
    return PDFPageTextLayout.endPDFPageTextLayout(builder)
  }
}
